module.exports = __webpack_public_path__ + "media/notif.7ad935d5.mp3";